import React, {
  CSSProperties,
  createContext,
  forwardRef,
  ReactNode,
  useContext,
} from 'react'
import * as styles from './Section.module.scss'
import { getClassNameFactory } from '../../utils/get-class-name-factory'

const getClassName = getClassNameFactory('Section', styles)

export type SectionConfig = {
  maxWidth?: string
  centered?: boolean
  paddingInline?: string
}

export const SectionConfigContext = createContext<SectionConfig>({})

export type SectionProps = {
  className?: string
  children: ReactNode
  maxWidth?: string
  centered?: boolean
  paddingInline?: string
  style?: CSSProperties
}

export const Section = forwardRef<HTMLDivElement, SectionProps>(
  (
    { children, className, maxWidth, centered, paddingInline, style = {} },
    ref,
  ) => {
    const ctx = useContext(SectionConfigContext)

    const resolvedMaxWidth = maxWidth ?? ctx.maxWidth ?? '1280px'
    const rawCentered = centered ?? ctx.centered ?? true
    const resolvedCentered = rawCentered === true || rawCentered === 'true'
    const resolvedPaddingInline = paddingInline ?? ctx.paddingInline

    return (
      <div
        className={`${getClassName()}${className ? ` ${className}` : ''}`}
        style={{
          minHeight: 'inherit',
          height: 'inherit',
          ...(resolvedPaddingInline !== undefined &&
            ({
              '--section-padding-inline-start': resolvedPaddingInline,
              '--section-padding-inline-end': resolvedPaddingInline,
            } as CSSProperties)),
          ...style,
        }}
        ref={ref}
      >
        <div
          className={getClassName('inner')}
          style={{
            maxWidth: resolvedMaxWidth,
            marginInline: resolvedCentered ? 'auto' : '0',
            width: '100%',
            minHeight: 'inherit',
            height: 'inherit',
          }}
        >
          {children}
        </div>
      </div>
    )
  },
)
